import './styling/showusers.css'

export default function () {
  return (
    <div className='showusers-component'>
      ONLY AS an administrator show all users here. CRUD.
    </div>
  )
}